import { Injectable } from '@angular/core';
import { DeviceSettings } from 'src/deviceSettings';
import { Logger } from "src/logger";
import { NgZone } from '@angular/core';
import { LoggerService } from 'src/loggerService';
import { LocalTimeZoneClock } from 'src/clock';
import { TizenVideoReservationManager } from './tizenVideoReservationManager';
import { TizenAvPlaySharedListener } from './tizenAvPlaySharedListener';

@Injectable({
    providedIn: "root"
})
export class TizenVideoDisplayHandlerDependencies {
    constructor(
        readonly deviceSettings: DeviceSettings,
        readonly logger: Logger,
        readonly ngZone: NgZone,
        readonly loggerService: LoggerService,
        readonly localTimeZoneClock: LocalTimeZoneClock,
        readonly tizenVideoReservationManager : TizenVideoReservationManager,
        readonly tizenAvPlaySharedListener : TizenAvPlaySharedListener
    ) {
    }
}